import { useCallback, useState } from 'react';
import styles from './GradeSelectModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import CloseIcon from '@src/assets/icons/close.svg?react';
import { useQueryDictionary } from '@src/hooks';
import { SelectOption } from '@src/types';
import { auProgramGradeLevels } from '@src/constants';
import Select from '@src/components/select/Select';

type Props = {
  open: boolean;
  onClose: () => void;
  onContinue: (programName: string) => void;
};

function GradeSelectModal(props: Props) {
  const { open, onClose, onContinue } = props;
  
  const [grade, setGrade] = useState('')

  const programOptions = useQueryDictionary({ dictionary: 'Programs' });

  const handleNext = useCallback(() => {
    const gradeId = programOptions.find(program => program.label.includes(grade))?.label
    onContinue(gradeId ?? "")
  }, [grade, programOptions, onContinue])

  const handleChangeGrade = (group: SelectOption) => {
    setGrade(group.value)
  }

  return (
    <Modal global={true} open={open} onClose={onClose} closeButton={false} className={styles.wrapper} >
      <div className={styles.mainView}>
        <button onClick={onClose} className={styles.closeWrapper}>
          <CloseIcon className={styles.closeIcon} />
        </button>
        <>
          <div className={styles.header}>
            <div className={styles.preProTitle}>{'What Year are your Students in?'}</div>
            <div className={styles.normalText}>
              Please select from the available options below. There are unique Pre-Program Quizzes available for Year 4 to Year 12.
            </div>
          </div>
          <div className={styles.inputView}>
            <Select menuClassName={styles.selectorStyle} className={styles.gradeView} showSearch={false} inline={false} doNotSort={true} placeholder={'Select Your Year Level'} value={grade} options={auProgramGradeLevels} onChange={handleChangeGrade}/>
          </div>
          <div className={styles.content}>
            <div className={styles.action}>
              <Button disabled={!programOptions || programOptions.length === 0 } size="small" className={styles.startButton} onClick={handleNext} label={'CONTINUE'} />
            </div>
          </div>
        </>
      </div>
    </Modal>
  );
}

export default GradeSelectModal;
